import style from './teaser-standard.scss';

const script = () => {
  // Your script
};

export {
  style,
  script,
};
